import { AxiosError } from 'axios';

export function isAxiosStatus(error: unknown, status: number): boolean {
  return error instanceof AxiosError && error.response?.status === status;
}

export function isAxios404(error: unknown): boolean {
  return isAxiosStatus(error, 404);
}

export function extractAxiosMessage(error: unknown): string | null {
  if (!(error instanceof AxiosError)) {
    return null;
  }
  const data = error.response?.data;
  if (data && typeof data === 'object' && 'message' in data) {
    const message = (data as { message?: unknown }).message;
    if (typeof message === 'string') {
      return message;
    }
  }
  return error.message;
}
